import { combineReducers } from 'redux';
import year from './year';
import region from "./region";

let reduce = combineReducers({
    year: year,
    region: region,
})

export default reduce;


// WEBPACK FOOTER //
// ./src/reducers/index.js